"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  colorPicker: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.white,
    width: 'fit-content',
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity
    },
    '& .chrome-picker': {
      boxShadow: 'none !important'
    }
  },
  closeBtn: {
    margin: `0 ${theme.spaceSize.small}px ${theme.spaceSize.small}px`
  }
});

exports.default = _default;